exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1Nraox7Q8xTKaI{display:block;color:#fff;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Noto Sans,Ubuntu,Droid Sans,Helvetica Neue,sans-serif;font-weight:400;padding:12px 2px 12px 12px;justify-content:left;align-items:center}._1Nraox7Q8xTKaI._1N42O628umKF5A{display:flex;flex-direction:row}._2lo03zrRpr-SZt{box-shadow:0 1px 1px rgba(9,30,66,.25),0 0 0 1px rgba(9,30,66,.08)}._2DDQYnTwWGhpkv{display:flex}._3BpNwLiW46PKxU{color:#172b4d;flex-grow:1;width:100%;margin-top:7px;font-size:20px;font-weight:600}._3BpNwLiW46PKxU.PSVsh6vqc7cqkj,._3BpNwLiW46PKxU.PSVsh6vqc7cqkj a{color:#fff}._2UrUzVg7qmx4oy{border-radius:3px}.QeZgUcmD01l6oM{align-self:flex-start;justify-self:right;cursor:pointer}.AHyyfb6G_ktbl5{padding-right:6px;flex-grow:1;color:#172b4d;font-size:14px;line-height:24px}.AHyyfb6G_ktbl5 a{color:#172b4d}.AHyyfb6G_ktbl5.PSVsh6vqc7cqkj,.AHyyfb6G_ktbl5.PSVsh6vqc7cqkj a{color:#fff}", ""]);

// exports
exports.locals = {
	"narrowBannerContainer": "_1Nraox7Q8xTKaI",
	"noHeader": "_1N42O628umKF5A",
	"bannerShadow": "_2lo03zrRpr-SZt",
	"topRow": "_2DDQYnTwWGhpkv",
	"headerBody": "_3BpNwLiW46PKxU",
	"lightText": "PSVsh6vqc7cqkj",
	"roundedCorners": "_2UrUzVg7qmx4oy",
	"closeButton": "QeZgUcmD01l6oM",
	"textContent": "AHyyfb6G_ktbl5"
};